<template>
  <el-card>
    <div slot="header">
      Cím adatok
    </div>
    <el-form
      ref="addressForm"
      label-position="top"
      :model="addressData"
      :rules="rules"
    >
      <el-form-item>
        <el-switch
          v-model="has_address"
          active-text="Adok meg címet"
        />
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Irányítószám"
            prop="postal_code"
          >
            <el-input
              v-model="addressData.postal_code"
              :disabled="!has_address"
              @change="onZipChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            v-loading="addressLoading"
            label="Város"
            prop="city"
          >
            <el-input
              v-model="addressData.city"
              :disabled="!has_address"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Ország"
            prop="country_id"
            v-loading="addressLoading"
            :disabled="has_address"
          >
            <el-select
              v-model="addressData.country_id"
              value-key="id"
              style="width: 100%;"
              filterable
              :disabled="!has_address"
            >
              <el-option
                v-for="country in countries"
                :key="country.id"
                :value="country.id"
                :label="country.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Megye"
            prop="county"
            v-loading="addressLoading"
          >
            <el-select
              v-model="addressData.county_id"
              value-key="id"
              style="width: 100%;"
              filterable
              :disabled="!has_address"
            >
              <el-option
                v-for="county in counties"
                :key="county.id"
                :value="county.id"
                :label="county.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Cím"
            prop="address"
          >
            <el-input
              v-model="addressData.address"
              :disabled="!has_address"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>
<script>
  export default {
    props: ['address'],
    data() {
      return {
        has_address: false,
        addressLoading: false,
        addressData: {},
        rules: {
          country_id: [
            { required: true, message: 'Ország megadása kötekező', trigger: 'change' }
          ],
          postal_code: [
            { required: true, message: 'Irányítószám megadása kötekező', trigger: 'change' }
          ],
          city: [
            { required: true, message: 'Város megadása kötekező', trigger: 'change' }
          ],
          address: [
            { required: true, message: 'Cím kötekező', trigger: 'change' }
          ],
        },
      };
    },
    computed: {
      locations() {
        return this.$store.getters['location/locations'];
      },
      users() {
        return this.$store.getters['user/users'];
      },
      countries() {
        return this.$store.getters['country/countries'];
      },
      counties() {
        return this.$store.getters['county/counties'];
      }
    },
    watch: {
      address(newVal) {
        if(newVal) {
          this.addressData = JSON.parse(JSON.stringify(newVal));
          this.has_address = true;
        } else {
          this.addressData = {};
          this.has_address = false;
        }
      },
    },
    methods: {
      add() {
        this.$emit('add');
      },
      async onZipChange() {
        this.addressLoading = true;
        const data = await axios.get('/api/city/' + this.addressData.postal_code);
        if (data) {
          this.$set(this.addressData, 'city', data.city);
          this.$set(this.addressData, 'county_id', data.county_id);
          this.$set(this.addressData, 'county', this.counties.find(c => c.id === data.county_id));
          this.$set(this.addressData, 'country_id', data.country_id);
          this.$set(this.addressData, 'country', this.countries.find(c => c.id === data.country_id));
        } else {
          this.$set(this.addressData, 'city', null);
          this.$set(this.addressData, 'county', null);
          this.$set(this.addressData, 'county_id', null);
        }
        this.addressLoading = false;
      },
    }
  };
</script>
